// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.municipality-invoice-table {
  table-layout: fixed;
}

table.municipality-invoice-table > thead > tr.header-row > th,
table.municipality-invoice-table > thead > tr.sub-header-row > th {
  font: bold 11px/15px "Roboto";
  letter-spacing: 0.22px;
  color: #424242;
  background-color: #FFF;
  top: 0;
  position: sticky;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th {
  height: 60px;
  padding: 0px;
  padding-left: 15px;
  padding-right: 15px;
}

table.municipality-invoice-table > thead > tr.header-row > th {
  height: 50px;
  padding: 0px;
}

table.municipality-invoice-table > thead > tr.header-row > th:first-child,
table.municipality-invoice-table > thead > tr.header-row > th:last-child {
  background-color: transparent;
}

table.municipality-invoice-table > thead > tr.header-row > th.electricity {
  background-color: #C5E369;
  color: white;
  font-size: 17px;
  line-height: 12px;
  font-weight: 500;
}

table.municipality-invoice-table > thead > tr.header-row > th.water {
  background-color: #329FA2;
  color: white;
  font-size: 17px;
  line-height: 12px;
  font-weight: 500;
}

table.municipality-invoice-table > thead > tr.header-row > th.other {
  background-color: #FF9234;
  color: white;
  font-size: 17px;
  line-height: 12px;
  font-weight: 500;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th {
  font-size: 12px;
  line-height: 15px;
  font-weight: 700;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th:first-child {
  border-top-left-radius: 4px;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.accountNumber {
  z-index: 2;
  left: 0px;
  background-color: #549DA0;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.dueDate {
  z-index: 2;
  left: 100px;
  background-color: #77B1B2;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-s1 {
  background-color: #F0FCC8;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-s2 {
  background-color: #E3F4AA;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-consumption-kwh {
  background-color: #B4CA6D;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-s3 {
  background-color: #D2E788;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-usage-zar {
  background-color: #B4CA6D;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-total-cost {
  background-color: #52785D;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.water-s1 {
  background-color: #93C1C3;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.water-total-consumption {
  background-color: #77B1B2;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.water-total-consumption-cost {
  background-color: #61A1A3;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.water-total-cost {
  background-color: #508487;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.property-s1 {
  background-color: #FFC593;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.property-s2 {
  background-color: #FFC493;
  font-size: 10px;
  line-height: 12px;
  font-weight: 400;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.property-total {
  background-color: #DB5E16;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-excl-vat {
  background-color: #0C703F;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-vat {
  background-color: #124626;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-incl-vat {
  background-color: #063317;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-credit {
  background-color: #39007E;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

table.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-rebill {
  background-color: #39007E;
  font-size: 10px;
  line-height: 12px;
  font-weight: 700;
  color: white;
}

.bceg {
  background-color: #E3F2AA;
}

.bceg1 {
  background-color: #D2E788;
}

.bceg > p,
.bceg1 > p {
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  color: #424242;
}

input.electricity {
  width: 100%;
  flex: 1;
  font: 700 13px/15px Roboto;
  letter-spacing: 0.26px;
  color: #424242;
  border: none;
  background-color: transparent;
  padding: 0px;
  padding-bottom: 5px;
  text-align: center;
  border-bottom: 2px solid #424242;
  cursor: text !important;
}

input.electricity:focus {
  outline: none;
  border-bottom: 1px solid;
  margin-bottom: -1px;
}

input.electricity::-webkit-outer-spin-button,
input.electricity::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input.electricity input[type=number] {
  -moz-appearance: textfield;
}

div.grid2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

table.municipality-invoice-table > tbody > tr.row {
  cursor: pointer;
}

table.municipality-invoice-table > tbody > tr.row > td {
  font-size: 12px;
  font-weight: 400;
}

table.municipality-invoice-table > tbody > tr.row > td.accountNumber {
  position: sticky;
  font-size: 11px;
  font-weight: 700;
  color: white;
  background-color: #73B0B3;
  z-index: 2;
  left: 0px;
}

table.municipality-invoice-table > tbody > tr.row > td.dueDate {
  position: sticky;
  font-size: 11px;
  font-weight: 700;
  color: white;
  background-color: #A3C9CA;
  z-index: 2;
  left: 100px;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.accountNumber {
  background-color: #6DAAAB;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.dueDate {
  background-color: #9CC0C2;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.electricity-consumption {
  background-color: #ACC268;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.electricity-consumption {
  background-color: #B4CA6D;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.electricity-total {
  background-color: #507259;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.electricity-total {
  background-color: #0F4323;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.water-total-consumption {
  background-color: #71A9AB;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.water-total-consumption {
  background-color: #77B1B2;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.water-total-consumption-cost {
  background-color: #5C9A9C;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.water-total-consumption-cost {
  background-color: #61A1A3;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.water-total-cost {
  background-color: #4C7E81;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.water-total-cost {
  background-color: #508487;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.property-rates-total {
  background-color: #D27525;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.property-rates-total {
  background-color: #DB7A27;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-excl {
  background-color: #74A88F;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-excl {
  background-color: #79B095;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-vat {
  background-color: #61826D;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-vat {
  background-color: #658872;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-incl {
  background-color: #6F8277;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-incl {
  background-color: #74887C;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-credit,
table.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-rebill {
  background-color: #AC9EBD;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-credit,
table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-rebill {
  background-color: #B4A5C5;
  color: white;
  font-weight: 700;
}

table.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td:not(.no-hover) {
  background-color: #F4F4F4;
}

table.municipality-invoice-table > tbody > tr.row:hover > td:not(.no-hover),
table.municipality-invoice-table > tbody > tr.row.selected > td:not(.no-hover) {
  background-color: #339FA2;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/style/transformer/MunicipalityInvoice.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AAEA;;EAEI,6BAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;EACA,MAAA;EACA,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;EACA,YAAA;AACJ;;AAEA;;EAEI,6BAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,UAAA;EACA,SAAA;EACA,yBAAA;EACA,YAAA;AACJ;;AAEA;EACI,UAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AACJ;;AACA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EAAQ,yBAAA;AAER;;AADA;EAAS,yBAAA;AAKT;;AAHA;;EAEI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAMJ;;AAHA;EACI,WAAA;EACA,OAAA;EACA,0BAAA;EACA,sBAAA;EACA,cAAA;EAEA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,uBAAA;AAIJ;;AADA;EACI,aAAA;EACA,wBAAA;EACA,mBAAA;AAIJ;;AADA;;EAEE,wBAAA;EACA,SAAA;AAIF;;AADA,YAAA;AACA;EACE,0BAAA;AAIF;;AADA;EACI,aAAA;EACA,qCAAA;AAIJ;;AADA;EACI,eAAA;AAIJ;;AADA;EACI,eAAA;EACA,gBAAA;AAIJ;;AADA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,SAAA;AAIJ;;AADA;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;;EAEI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;;EAEI,yBAAA;EACA,YAAA;EACA,gBAAA;AAIJ;;AADA;EACI,yBAAA;AAIJ;;AADA;;EAEI,yBAAA;EACA,YAAA;AAIJ","sourcesContent":["table.municipality-invoice-table {\n    table-layout: fixed;\n}\n\ntable.municipality-invoice-table > thead > tr.header-row > th,\ntable.municipality-invoice-table > thead > tr.sub-header-row > th {\n    font: bold 11px/15px 'Roboto';\n    letter-spacing: 0.22px;\n    color: #424242;\n    background-color: #FFF;\n    top: 0;\n    position: sticky;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th {\n    height: 60px;\n    padding: 0px;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\ntable.municipality-invoice-table > thead > tr.header-row > th {\n    height: 50px;\n    padding: 0px;\n}\n\ntable.municipality-invoice-table > thead > tr.header-row > th:first-child,\ntable.municipality-invoice-table > thead > tr.header-row > th:last-child {\n    background-color: transparent;\n}\n\ntable.municipality-invoice-table > thead > tr.header-row > th.electricity {\n    background-color: #C5E369;\n    color: white;\n    font-size: 17px;\n    line-height: 12px;\n    font-weight: 500;\n}\n\ntable.municipality-invoice-table > thead > tr.header-row > th.water {\n    background-color: #329FA2;\n    color: white;\n    font-size: 17px;\n    line-height: 12px;\n    font-weight: 500;\n}\n\ntable.municipality-invoice-table > thead > tr.header-row > th.other {\n    background-color: #FF9234;\n    color: white;\n    font-size: 17px;\n    line-height: 12px;\n    font-weight: 500;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th {\n    font-size: 12px;\n    line-height: 15px;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th:first-child {\n    border-top-left-radius: 4px;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.accountNumber {\n    z-index: 2;\n    left: 0px;\n    background-color: #549DA0;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.dueDate {\n    z-index: 2;\n    left: 100px;\n    background-color: #77B1B2;\n    color: white;\n}\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-s1 {\n    background-color: #F0FCC8;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 400;\n    \n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-s2 {\n    background-color: #E3F4AA;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 400;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-consumption-kwh {\n    background-color: #B4CA6D;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-s3 {\n    background-color: #D2E788;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 400;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-usage-zar {\n    background-color: #B4CA6D;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.electricity-total-cost {\n    background-color: #52785D;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.water-s1 {\n    background-color: #93C1C3;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 400;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.water-total-consumption {\n    background-color: #77B1B2;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.water-total-consumption-cost {\n    background-color: #61A1A3;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.water-total-cost {\n    background-color: #508487;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.property-s1 {\n    background-color: #FFC593;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 400;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.property-s2 {\n    background-color: #FFC493;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 400;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.property-total {\n    background-color: #DB5E16;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-excl-vat {\n    background-color: #0C703F;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-vat {\n    background-color: #124626;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-incl-vat {\n    background-color: #063317;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-credit {\n    background-color: #39007E;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\ntable.municipality-invoice-table > thead > tr.sub-header-row > th.total-invoice-rebill {\n    background-color: #39007E;\n    font-size: 10px;\n    line-height: 12px;\n    font-weight: 700;\n    color: white;\n}\n\n.bceg { background-color: #E3F2AA; }\n.bceg1 { background-color: #D2E788; }\n\n.bceg > p,\n.bceg1 > p {\n    font-weight: 700;\n    font-size: 12px;\n    line-height: 15px;\n    color: #424242;\n}\n\ninput.electricity {\n    width: 100%;\n    flex: 1;\n    font: 700 13px/15px Roboto;\n    letter-spacing: 0.26px;\n    color: #424242;\n\n    border: none;\n    background-color: transparent;\n    padding: 0px;\n    padding-bottom: 5px;\n    text-align: center;\n    border-bottom: 2px solid #424242;\n\n    cursor: text !important;\n}\n\ninput.electricity:focus {\n    outline: none;    \n    border-bottom: 1px solid;\n    margin-bottom: -1px;\n}\n\ninput.electricity::-webkit-outer-spin-button,\ninput.electricity::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput.electricity input[type=number] {\n  -moz-appearance: textfield;\n}\n\ndiv.grid2 {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n}\n\ntable.municipality-invoice-table > tbody > tr.row {\n    cursor: pointer;\n}\n\ntable.municipality-invoice-table > tbody > tr.row > td {\n    font-size: 12px;\n    font-weight: 400;\n}\n\ntable.municipality-invoice-table > tbody > tr.row > td.accountNumber {\n    position: sticky;\n    font-size: 11px;\n    font-weight: 700;\n    color: white;\n    background-color: #73B0B3;\n    z-index: 2;\n    left: 0px;\n}\n\ntable.municipality-invoice-table > tbody > tr.row > td.dueDate {\n    position: sticky;\n    font-size: 11px;\n    font-weight: 700;\n    color: white;\n    background-color: #A3C9CA;\n    z-index: 2;\n    left: 100px;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.accountNumber {\n    background-color: #6DAAAB;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.dueDate {\n    background-color: #9CC0C2;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.electricity-consumption {\n    background-color: #ACC268;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.electricity-consumption {\n    background-color: #B4CA6D;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.electricity-total {\n    background-color: #507259;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.electricity-total {\n    background-color: #0F4323;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.water-total-consumption {\n    background-color: #71A9AB;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.water-total-consumption {\n    background-color: #77B1B2;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.water-total-consumption-cost {\n    background-color: #5C9A9C;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.water-total-consumption-cost {\n    background-color: #61A1A3;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.water-total-cost {\n    background-color: #4C7E81;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.water-total-cost {\n    background-color: #508487;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.property-rates-total {\n    background-color: #D27525;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.property-rates-total {\n    background-color: #DB7A27;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-excl {\n    background-color: #74A88F;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-excl {\n    background-color: #79B095;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-vat {\n    background-color: #61826D;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-vat {\n    background-color: #658872;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-incl {\n    background-color: #6F8277;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-incl {\n    background-color: #74887C;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-credit,\ntable.municipality-invoice-table > tbody > tr.row:nth-child(even) > td.invoice-total-rebill  {\n    background-color: #AC9EBD;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-credit,\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td.invoice-total-rebill {\n    background-color: #B4A5C5;\n    color: white;\n    font-weight: 700;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:nth-child(odd) > td:not(.no-hover) {\n    background-color: #F4F4F4;\n}\n\ntable.municipality-invoice-table > tbody > tr.row:hover > td:not(.no-hover),\ntable.municipality-invoice-table > tbody > tr.row.selected > td:not(.no-hover) {\n    background-color: #339FA2;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
